import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import reportsService from "../api/reportsService";
import { RecommendationHistoryEntry, Reports, ReportsPaginated, Users } from "../types/types";
import authService from "../api/authService";




export const useGetReports = (id?: number, page = 0, pageSize = 10) => {
    return useQuery<ReportsPaginated>({
        queryKey: ['reports', id, page, pageSize],
        queryFn: async () => {
            const response = await reportsService.getAll(id, page, pageSize);
            return response?.data;
        },
        refetchOnWindowFocus: false,
    } as UseQueryOptions<ReportsPaginated>);
};

export const useGetReportById = (reportId?: number, ownerUserId?: number) => {
    return useQuery<Reports>({
        queryKey: ['report', reportId, ownerUserId],
        queryFn: async () => {
            const response = await reportsService.getById(reportId!, ownerUserId);
            return response?.data;
        },
        enabled: reportId != null && reportId > 0 && ownerUserId != null && ownerUserId > 0,
        refetchOnWindowFocus: false,
    } as UseQueryOptions<Reports>);
};
export const useGetReportsAdmin = (id: number | undefined, page: number, pageSize: number) => {
    return useQuery<ReportsPaginated>({
        queryKey: ['reportsAdmin', id, page, pageSize],
        queryFn: async () => {
            const response = await reportsService.getAllAdmin(id, page, pageSize);
            return response?.data;
        },
        enabled: id != null && id > 0,
        refetchOnWindowFocus: false,
    } as UseQueryOptions<ReportsPaginated>);
};
export const useGetUsers = () => {
    return useQuery<Users[]>({
        queryKey: ['users'],
        queryFn: async () => {
            const response = await authService.getUsers()
            return Promise.resolve(response?.data);
        },
        refetchOnWindowFocus: false,
    } as UseQueryOptions<Users[]>);
}

export const useRecommendationsHistory = (reportId: number | undefined, userId: number | undefined) => {
    return useQuery<RecommendationHistoryEntry[]>({
        queryKey: ['recommendationsHistory', reportId, userId],
        queryFn: () => authService.getRecommendationsHistory({ reportId, userId }),
        enabled: reportId != null && userId != null,
        refetchOnWindowFocus: false,
    } as UseQueryOptions<RecommendationHistoryEntry[]>);
}

//todo
/*
export const  useDeleteStocks = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (id: string) => {
            await stockService.deleteStocks(Number(id))
        },
        onMutate: (id: string) => {
            queryClient.setQueryData(['stocks'], (prevs: any) =>
                prevs?.filter((stock: Stock) => stock.id !== id),
            );
        },
         onSettled: () => queryClient.invalidateQueries({ queryKey: ['stocks'] }),
    }as UseMutationOptions<Stock, unknown, Stock>);
}*/
